module.exports = __webpack_public_path__ + "static/zwings-logo-6f21157eff55f40e0112afd9a135b54e.png";